// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V7BzV","right":"styles_right__3hc7B"};